<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn class="mx-1" v-on="on" small color="secondary" fab dark @click="handleClick">
                <div style="border-radius: 50px; background-color: var(--v-white_highlight-base);" class="px-1 py-1">
                    <v-icon v-if="icon != '' && icon != null" aria-hidden="false" color="secondary" style="font-size: 30px;">{{ icon }}</v-icon>
                </div>
            </v-btn>
        </template>

        <span>{{ $t(label) }}</span>
    </v-tooltip>
</template>

<script>
    export default {
        props: [
            'label',
            'icon'
        ],
        data() {
            return {}
        },
        methods: {
            handleClick() {
                this.$emit('click')
            }
        }
    }
</script>